import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from 'semantic-ui-react'
import LocationForm from '~/pages/Dairy/DairyFactory/Managers/CreateManager/LocationForm'
import { FarmerCreateOptionsType } from '~/api/services/farmers'
import { StyledFormSection } from '../style'
import { ICountry } from '~/api/services/dairy'

interface Props {
  farmerOptions: FarmerCreateOptionsType
  countries: ICountry[]
}

const Location: React.FC<Props> = ({ farmerOptions, countries }) => {
  const { t } = useTranslation()

  return (
    <StyledFormSection>
      <div className='section-header'>
        <Icon name='map marker alternate' />
        <span className='section-title'>{t('Location')}</span>
      </div>
      <div className='section-content'>
        <LocationForm
          countries={countries}
          collectionSiteOptions={farmerOptions}
          useGoogleMapLocation
        />
      </div>
    </StyledFormSection>
  )
}

export default Location
